module.exports = __webpack_public_path__ + "img/multi_w.bc7955dc.svg";